<template>
    <div class="content-toggle" :class="toggleClass">
        <div class="content-toggle--header" @click="toggleContent">
            <translate>{{ toggle }}</translate>
            <form-button type="button" :icon="toggleIcon" dense="true" />
        </div>
        <div class="content-toggle--content">
            <slot />
        </div>
    </div>
</template>

<script>
import FormButton from '@partfactory/Shared/Form/FormButton';
export default {
    name: 'ContentToggle',
    components: {FormButton},
    props: [
        'toggle',
        'isToggled',
    ],
    data() {
        return {
            isToggledProxy: this.isToggled ? this.isToggled : false,
        };
    },
    computed: {
        toggleClass() {
            return this.isToggledProxy ? 'content-toggle--toggled' : '';
        },
        toggleIcon() {
            return this.isToggledProxy ? 'chevron-up' : 'chevron-down';
        }
    },
    methods: {
        toggleContent() {
            return this.isToggledProxy = !this.isToggledProxy;
        }
    }
};
</script>
